import { useState } from "react";
import Modal from "react-modal";
import { useParams } from "react-router-dom";
import api from "@/components/customAxios/Axios";
import { useLoader } from "@/context/loaderContext";
import { useToast } from "@/components/toast";
Modal.setAppElement("#root");
const customStyles = {
	overlay: {
		backgroundColor: "rgba(0, 0, 0, 0)", // fully transparent; change to rgba(0,0,0,0.5) for dim without blur
	},
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		transform: "translate(-50%, -50%)",

		borderRadius: "10px",
		maxWidth: "500px",
		maxHeight: "650px",
		zIndex: 1000,
	},
};
interface BehaviourQuestion {
	b_question_id: string | number;
	b_question_text: string;
}

interface TechQuestion {
	question: string;
	options: {
		A: string;
		B: string;
		C: string;
		D: string;
	};
	answer: string;
}

interface CodingQuestion {
	question: string;
	sample_input: string;
	sample_output: string;
}

const DeleteQuestionModal = ({
	currentQuestionIndex,
	section,
	codingQuestionSet,
	behaviouralQuestionSet,
	technicalQuestionSet,
	getQuestions,
}: {
	codingQuestionSet?: CodingQuestion[];
	behaviouralQuestionSet?: BehaviourQuestion[];
	technicalQuestionSet?: TechQuestion[];
	currentQuestionIndex: number;
	section: string;
	getQuestions: () => void;
}) => {
	const { setLoading } = useLoader();
	const toast = useToast();
	const { id } = useParams();
	const [modalIsOpen, setIsOpen] = useState(false);

	function openModal() {
		setIsOpen(true);
	}

	function closeModal() {
		setIsOpen(false);
	}

	const deleteQuestion = async () => {
		let updatedQuestions;
		let updatedQuestionsPayload: any = {};
		if (section === "coding" && codingQuestionSet) {
			updatedQuestions = codingQuestionSet.filter(
				(_, i) => i !== currentQuestionIndex
			);
			updatedQuestionsPayload["coding_question"] = updatedQuestions;
		} else if (section === "behavioral" && behaviouralQuestionSet) {
			updatedQuestions = behaviouralQuestionSet.filter(
				(_, i) => i !== currentQuestionIndex
			);
			updatedQuestionsPayload["behaviour_questions"] = updatedQuestions;
		} else if (section === "technical" && technicalQuestionSet) {
			updatedQuestions = technicalQuestionSet.filter(
				(_, i) => i !== currentQuestionIndex
			);
			updatedQuestionsPayload["tech_questions"] = updatedQuestions;
		}

		try {
			setLoading(true);
			const response = await api.post("job_description_question_management", {
				data: updatedQuestionsPayload,
				job_id: id,
				section,
			});
			if (response.status === 200) {
				toast.success({
					type: "background",
					duration: 5000,
					status: "success",
					title: "Question Deleted Successfully",
					description: "The question has been deleted successfully.",
					open: true,
				});
				getQuestions();
				closeModal();
			}
		} catch (error: any) {
			toast.error({
				type: "background",
				duration: 5000,
				status: "error",
				title: "Error Deleting Question",
				description: error.response?.data?.error || error.response?.data?.message || "Failed to delete the question. Please try again.",
				open: true,
			});
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="">
			<div className="relative group">
				<button
					onClick={openModal}
					className="text-lg font-heading font-semibold hover:scale-110 transition"
				>
					<svg
						width="17"
						height="18"
						viewBox="0 0 17 18"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M2.58398 5.25V15.6667C2.58398 15.9982 2.71568 16.3161 2.9501 16.5505C3.18452 16.785 3.50246 16.9167 3.83398 16.9167H13.0006C13.3322 16.9167 13.6501 16.785 13.8845 16.5505C14.119 16.3161 14.2506 15.9982 14.2506 15.6667V5.25H2.58398Z"
							stroke="black"
						/>
						<path
							d="M5.08398 7.67501V14.4917M8.41732 7.67501V14.4917M11.7507 7.67501V14.4917M5.50065 2.61084V1.70334C5.50065 1.13084 6.02315 0.666672 6.66732 0.666672H10.1673C10.8115 0.666672 11.334 1.13084 11.334 1.70334V2.61167"
							stroke="black"
							strokeLinecap="round"
						/>
						<path
							d="M14.667 2.75H2.16699C1.47664 2.75 0.916992 3.30964 0.916992 4C0.916992 4.69036 1.47664 5.25 2.16699 5.25H14.667C15.3573 5.25 15.917 4.69036 15.917 4C15.917 3.30964 15.3573 2.75 14.667 2.75Z"
							stroke="black"
						/>
					</svg>
				</button>
				<p className="absolute w-max text-center right-2 top-6 px-2 py-1 text-sm bg-black text-white rounded -z-10 group-hover:z-50 transition duration-300 ease-in-out">
					Delete Question
				</p>
			</div>

			<Modal
				isOpen={modalIsOpen}
				onRequestClose={closeModal}
				style={customStyles}
				contentLabel="Example Modal"
			>
				<div className="">
					<p className="font-subheading text-gray-600 text-center ">
						Are you sure you want to delete this question ?
					</p>
					<div className="flex justify-end gap-4 mt-6">
						<button
							className="px-4 py-2 text-white bg-[#438437] rounded-md  transition"
							onClick={deleteQuestion}
						>
							Delete
						</button>
						<button
							className="px-4 py-2 text-white bg-black rounded-md  transition"
							onClick={closeModal}
						>
							Cancel
						</button>
					</div>
				</div>
			</Modal>
		</div>
	);
};

export default DeleteQuestionModal;
